import React, {Component} from 'react';
import { connect } from 'react-redux';
import {
  Layout,
  PageHeader,
  Breadcrumb,
  Button,
  Table,
  Tooltip,
} from 'antd';
import axios from 'axios';
import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import Moment from 'react-moment';
import { Constant } from "../../config";
import CostListingSearch from './CostListingSearch';
import VendorModal from "./Modals/Vendor";
import CostDetail from "./Modals/CostDetail";
import ChangeLogs from "./Modals/ChangeLogs";

const { Content } = Layout;
const ButtonGroup = Button.Group;

const routes = () => [
  {
    path: "",
    breadcrumbName: "Cost Listing",
  }
];

class CostListing extends Component {

  state = {
    vendorList: [],
    pagination: {},
    loading: false,
    enableVendorModal: false,
    countryList: [],
    enableCostDetailModal: false,
    enableChangeLogsModal: false,
    gatewayName: '',
    gatewayId: 0
  };

  columns = [
    {
      title: 'Vendor',
      dataIndex: 'gateway_name',
      key: 'gateway_name',
      render: (text, record) => {
        return record.gateway_name || '-'
      },
      align: 'center',
    },
    {
      title: 'Gateway',
      dataIndex: 'total_gateway',
      key: 'total_gateway',
      render: (text, record) => {
        return <div><div className="text-link" style={{color: 'inherit'}} onClick={() => this._viewVendor(record.gateway_id)}>{record.total_gateway} Country</div><div style={{color: 'rgba(0, 0, 0, 0.45)'}}>{record.total_main_gateway} Main Gateway</div></div>
      },
      align: 'center',
    },
    {
      title: 'Last Update',
      dataIndex: 'last_modified_cost',
      key: 'last_modified_cost',
      render: (text, record) => {
        if (record.last_modified_cost === 0) return '-'
        return <Moment unix tz="Etc/UTC" format="DD/MM/YYYY HH:mm">{record.last_modified_cost}</Moment>;
      },
      align: 'center',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return (
            <ButtonGroup>
              <Tooltip placement="top" title="View">
                <Button icon="eye" onClick={() => this._viewVendor(record.gateway_id)} />
              </Tooltip>
              <Tooltip placement="top" title="Change Logs">
                <Button icon="unordered-list" onClick={() => this._viewChangeLogs(record.gateway_id)} />
              </Tooltip>
            </ButtonGroup>
        );
      },
      align: 'center',
    },
  ];

  componentWillMount() {
    this.props.fetchMenuAction('price-management', 'cost-listing');
  }

  async componentDidMount() {
    await this._fetchCountryList()
    await this._fetchCostList()
  }

  _fetchCountryList = async () => {
    this.setState({ loading: true });
    const opt = {
      url: `${Constant.COUNTRY_API}?limit=0`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;
  
    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    let d = [];
    let data = resp.data.data
    if (data) {
      d = data;
    }
    this.setState({
      countryList: d,
      loading: false
    });
  };

  _fetchCostList = async (page = 1, limit = 10, filter = {order_by: 'id', order: 'asc', search: ''}) => {
    this.setState({ loading: true });

    const url = Constant.COST_PRICE_API;
    for (const key in filter) {
      if (!filter[key]) {
        delete filter[key];
      }
    }
    const options = {
      url,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
      params: {
        page,
        limit,
        ...filter,
      },
    };
    let resp;

    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }

    let pagination = { ...this.state.pagination };
    pagination.size = 'small';
    let d = [];

    let data = resp.data.data
    if (data) {
      d = data;
      pagination.total = resp.data.total_rows;
    }
    this.setState({
      loading: false,
      vendorList: d,
      pagination
    });
  };

  _handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this._fetchCostList(pager.current, pagination.pageSize);
  };

  _handleSearch = (values) => {
    const pagination = this.state.pagination;
    pagination.current = 1;
    this.setState({ 
      pagination,
      filter: values
    });
    this._fetchCostList(1, 10, values);
  };

  _viewVendor = (gatewayId) => {
    this.setState({
      gatewayId,
      enableVendorModal: true
    })
  }

  _viewChangeLogs = (gatewayId) => {
    this.setState({
      enableChangeLogsModal: true,
      gatewayId
    })
  }

  _onCloseVendorModal = () => {
    this.setState({
      gatewayId: 0,
      enableVendorModal: false
    })
  }

  _onCloseChangeLogsModal = () => {
    this.setState({
      enableChangeLogsModal: false,
      gatewayName: '',
      gatewayId: 0
    })
  }

  _addCostPrice = () => {
    this.setState({
      enableCostDetailModal: true
    })
  }

  _onCloseCostDetailModal = () => {
    this.setState({ 
      enableCostDetailModal: false
    });
  }

	render() {
    let propsTable = {
      columns: this.columns,
      dataSource: this.state.vendorList,
      rowKey: (record) => record.key,
      pagination: this.state.pagination,
      loading: this.state.loading,
      onChange: this._handleTableChange
    };

		return (
			<Layout>
        <Breadcrumb className="breadcrumb">
          {routes().map((route, idx) => (
            <Breadcrumb.Item key={idx}>
              {route.path ? <a href={route.path}>{route.breadcrumbName}</a> : route.breadcrumbName}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          title={<h2 style={{ fontWeight: "bold" }}>Cost Listing</h2>} />
          <Layout className="my-layout">
            <Content className="main-container">
              <div className='main-container-inner'>
                <CostListingSearch onSearch={this._handleSearch} onAddVendor={this._addCostPrice} />
              </div>
              <Table scroll={{ x: 'max-content' }} {...propsTable} />
            </Content>
        </Layout>
        {this.state.enableVendorModal && 
          <VendorModal 
            visible={this.state.enableVendorModal}
            gatewayId={this.state.gatewayId}
            countryList={this.state.countryList}
            onCancel={this._onCloseVendorModal}
          />
        }
        {this.state.enableCostDetailModal && 
          <CostDetail 
            visible={this.state.enableCostDetailModal}
            data={''}
            onCancel={this._onCloseCostDetailModal}
            countryList={this.state.countryList}
            gatewayName={''}
            costCountryName={''}
            isEditCost={false}
            gatewayId={''}
            addCostFromList={true}
            hasActivity={this._onCloseCostDetailModal}
          />
        }
        {this.state.enableChangeLogsModal && 
          <ChangeLogs 
            visible={this.state.enableChangeLogsModal}
            onCancel={this._onCloseChangeLogsModal}
            countryList={this.state.countryList}
            gatewayId={this.state.gatewayId}
          />
        }
      </Layout>
		)
	}
}

const mapDispatchToProps = dispatch => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) => dispatch(fetchMenuAction(menuParentKey, menuKey)),
  }
}

export default connect(null, mapDispatchToProps)(CostListing)


// WEBPACK FOOTER //
// ./src/containers/PriceManagement/CostListing.js